import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../CuppingTherapyTreatment/CuppingTherapyTreatment.css";
import CupImg from "../IMG/spa-concept-with-woman.jpg";
import BookingComponent from "../BookNow/BookNowCall";
import SEO from "../../../SEO";

const AyurvedicBodyMassage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="cupping-page-wrapper">
      <SEO
        title="Ayurvedic Body Massage | Ayurvedic Spa in Pune"
        description="Experience the best Ayurvedic Body Massage at Shrikrishna Arogyam in Pune. Visit us for affordable Ayurvedic Massage Therapy. Book Your Session!"
        keywords="Ayurvedic Body Massage"
        canonical="https://shrikrishnaarogyammassagestherapy.com/ayurvedic-body-massage"
      />
      {/* Animated Header */}
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="cupping-header"
      >
        <h1>
          Rejuvenate & Revitalize Your Mind, Body and Soul with our Ayurvedic
          Body Massage
        </h1>
      </motion.header>

      <Container className="cupping-content">
        <Row className="cupping-section">
          <Col md={6} className="cupping-image-col">
            <motion.img
              src={CupImg}
              alt="Cupping Therapy"
              className="cupping-image"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
            />
          </Col>
          <Col md={6} className="cupping-text-col">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
              className="cupping-description "
            >
              Ayurveda, India's ancient, ancient science of health and healing
              with over five millennia of history now comes to you in the form
              of{" "}
              <b>
                Shrikrishna Arogyam Massage Therapy's Ayurvedic Body Massage.
              </b>{" "}
              Our experience too is no less. Add these together, and what you
              get is ancient wisdom and contemporary relaxation & rejuvenation
              with our body massage. Not only are these relaxing, they also help
              to improve your health, reduce long-held aches and pains, and most
              of all, bring back the right balance to your body and mind. Each
              therapy is carefully customized after understanding your unique
              prakriti (body constitution), current imbalances, and lifestyle
              habits for optimal results.
              <br />
              For a natural and safe way to feel better, our{" "}
              <b> Ayurvedic Massage in Pune </b> is your best choice. Our reach
              extends all the way into Karve Nagar, Kothrud, Deccan, Baner,
              Balewadi, Aundh, and Panchvati in Pune.
            </motion.p>
          </Col>
        </Row>

        <h2 className="hiw">What Is Ayurvedic Body Massage?</h2>

        <Card className="cupping-card">
          <Card.Body>
            <Card.Text>
              <b>Abhyanga</b>, the most prevalent Ayurvedic massage, uses warm
              herbal oils and gentle but firm strokes. The oils, a mix of many,
              are selected based on one's body type, i.e., doshas and are
              administered by trained people who have the right knowledge and
              techniques of applying quantities and pressures, meaning every
              massage is entirely dependent on the person undergoing the
              therapy.
            </Card.Text>
          </Card.Body>
        </Card>

        <ul className="cupping-benefitssssssssss">
          <p style={{ fontWeight: "bold" }}>
            Abhyanga helps you in the following ways:
          </p>
          <li>It improves blood flow</li>
          <li>Reduces joint and muscle pains- old or new</li>
          <li>Remove toxins from the body</li>
          <li>Improves skin tone and health</li>
          <li>Boosts immunity to a very large extent</li>
          <li>Helps bring sleep, both fast and deep</li>
          <li>
            Reduce stress and anxiety, be it long-endured or something new.
          </li>
          <p>
            People undergoing our <b>Full Body Massage in Pune</b> end up
            feeling calm and happy with a deep sense of peace.
          </p>
        </ul>

        <h2>
          Why Choose Ayurvedic Massage in Pune at ShriKrishna Arogyam only?
        </h2>
        <p style={{ fontWeight: "bold" }}>
          We are one of the city's most trusted places for Ayurvedic massage. At
          the centre of this trust lies our personnel's being one of the most
          skilled at Abhyanga with the most revered citations, awards and
          certifications.
        </p>

        <ul className="cupping-benefitssssssssss">
          <p>What makes us different includes: </p>
          <li>
            Use of the best ingredients for Ayurvedic Massages, from oils to
            herbs
          </li>
          <li>Personalized packages for every client and their needs</li>
          <li>Trained therapists and massage-givers in Ayurveda</li>
          <li>Affordable packages</li>
          <li>Great, relaxing environment</li>
          <li>Use of the best means for hygiene and safety</li>
          <p>
            {" "}
            If you are lucky enough to be staying in Pune's Kothrud, Baner,
            Balewadi, Aundh, Panchvati, or nearby areas, our <b>
              Spas in Pune
            </b>{" "}
            is easy to reach. Every visit to our place for Ayurvedic massages is
            worthy, given that we go beyond massages to give an experience that
            helps you feel light, fresh, positive and strong.
          </p>
        </ul>

        <h2>We heal. Because we are beyond being just a Spa!</h2>
        <p>
          Spas only relax. For things beyond, visit us for long-term, sustained
          healing because we use India's ancient medical science, Ayurveda to go
          to the root of every need and bring long term relief with tailored
          massages. Coming to Shrikrishna Arogyam you feel great with long-term
          health benefits.
        </p>

        <h2>Who Should Try Our Ayurvedic Massage?</h2>
        <ul className="cupping-checklist">
          <p>
            While Ayurvedic massages are for everyone, they're especially
            helpful for:{" "}
          </p>
          <li>
            People with desk jobs who suffer constant back and neck pains.
          </li>
          <li>
            The elderly with multiple problems, especially restricted joint
            movements
          </li>
          <li>Women going through hormonal imbalances</li>
          <li>Athletes with muscles, bones and joint issues</li>
          <li>
            Others who want to improve every aspect of their health in the most
            natural of ways
          </li>
        </ul>

        <h2>Book Your Session Today!</h2>
        <p>
          <span style={{ display: "block" }}>
            You are your body. Care for it the same way you would care for a
            super-expensive car or gadget because it deserves such care. And the
            best way is a good <b>Ayurvedic Body Massage</b> from time to time.
          </span>
          {/* <br />{" "} */}
          <span style={{ display: "block" }}>
            Visit <b>Shrikrishna Arogyam</b> today to feel the world of
            difference. Because we are beyond being another{" "}
            <b>Ayurvedic Spa in Pune</b>.
          </span>
          <br />
          <span style={{ display: "block" }}>
            {" "}
            Call us now to book your appointment. We proudly serve clients from
            Kothrud, Karve Nagar, Deccan, Baner, Balewadi, Aundh, Panchvati,
            Wakad, Hinjewadi, Pimple Nilakh, Tathawade, Mahalunge, Sus, Pashan,
            Punawale, and PCMC and beyond.
          </span>
        </p>

        <BookingComponent />
      </Container>
    </div>
  );
};

export default AyurvedicBodyMassage;
